import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unread",
  "use": "icon-unread-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unread\"><path d=\"M508.4 575.1l400.8-383.4c-1.6-0.1-3.1-0.2-4.7-0.2H121.2c-4.3 0-8.4 0.5-12.4 1.4l399.6 382.2z\" fill=\"#EDC165\" p-id=\"1475\" /><path d=\"M958.6 233.2l-0.9 0.6-413.3 395.4c-10 9.5-23 14.3-36 14.3s-26.1-4.8-36-14.3l-406.7-389c-0.3 2.4-0.5 4.8-0.5 7.3v486c0 54 44 98 98 98h699.3c54 0 98-44 98-98v-486c-0.3-15.1-1.9-14.3-1.9-14.3z\" fill=\"#EDC165\" p-id=\"1476\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol